import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
// import { fetchLeaderboard, LeaderboardEntry } from '../../utils/api';
// import { getPlayerId } from '../../utils/playerIdentity';
import './Leaderboard.css';

interface LeaderboardProps {
  open: boolean;
  onClose: () => void;
}

// const MEDALS = ['🥇', '🥈', '🥉'];

const Leaderboard: React.FC<LeaderboardProps> = ({ open, onClose }) => {
  const titleId = React.useId();

  React.useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="lb-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="lb-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby={titleId}
          initial={{ opacity: 0, y: 40, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 40, scale: 0.95 }}
          transition={{ duration: 0.3 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className="lb-close" onClick={onClose} aria-label="Close leaderboard">
            &times;
          </button>

          <h2 id={titleId} className="lb-title">Leaderboard</h2>
          <p className="lb-subtitle">Top players by wins</p>

          <div className="lb-empty">
            <p>Leaderboard is currently offline.</p>
            <p className="lb-empty-hint">Your stats are saved locally in your profile.</p>
          </div>

          {/* Redis-backed leaderboard (commented out):
          {loading ? (
            <div className="lb-loading">Loading...</div>
          ) : entries.length === 0 ? (
            <div className="lb-empty">
              <p>No entries yet.</p>
              <p className="lb-empty-hint">Play some games to appear here!</p>
            </div>
          ) : (
            <div className="lb-list">
              {entries.map((entry, i) => {
                const isMe = entry.playerId === playerId;
                return (
                  <motion.div
                    key={entry.playerId}
                    className={`lb-row ${isMe ? 'lb-row-me' : ''}`}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: i * 0.04 }}
                  >
                    <span className="lb-rank">
                      {i < 3 ? MEDALS[i] : `#${i + 1}`}
                    </span>
                    <span className="lb-name">
                      {entry.name || 'Unknown'}
                      {isMe && <span className="lb-you-tag">You</span>}
                    </span>
                    <span className="lb-wins">{entry.wins} W</span>
                  </motion.div>
                );
              })}
            </div>
          )}
          */}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default Leaderboard;
